import React from 'react'
import {Swiper,SwiperSlide} from "swiper/react"
import SwiperCore,{EffectCoverflow,Pagination,Navigation} from "swiper/core"
// import "swiper/swiper.min.css";
// import "swiper/components/effect-coverflow/effect-coverflow.min.css"
// import "swiper/components/pagination/pagination.min.css"
// import "swiper/components/navigation/navigation.min.css"
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import './Training.scss'
import JAVA from "../img/JAVA card.png"
import DSA from "../img/DSA.png"
import Frontend from "../img/Frontend.png"
import Backend from "../img/Backend.png"
import Html from "../img/html.png"
import css from "../img/css.png"
import js from "../img/js.png"
import jquery from "../img/jquery.png"
import reactjs from "../img/reactjs.png"
import frontenddec from "../img/frontenddev.png"
import Loader from 'react-loaders'


SwiperCore.use([EffectCoverflow,Pagination,Navigation])


function Training() {
  return (
      <>
    <div className='container'>
        <div className='training-page text-zone '>
            <div className='textZone'>
                <h1 className='text-[#63e8ff] font-bold text-md md:text-xl top-0 mb-3'>Training and Certifications</h1>

            </div>
        </div>
        <div className='swiper-container'>
        <Swiper
        navigation={true}
        effect={"coverflow"}
        centeredSlides={true}
        slidesPerView={window.innerWidth <768?1:"auto"}
        loop={true}
        coverflowEffect={{
            rotate:50,
            stretch:0,
            depth:100,
            modifier:1,
            slideShadows:true
        }}
        pagination={{
            clickable:true
        }} classname="mySwiper">
        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700' src={Html} />
        </SwiperSlide>

        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700'  src={JAVA} />

        </SwiperSlide>
        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700'  src={css} />
            
        </SwiperSlide>
        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700'  src={js} />
        </SwiperSlide>
        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700'  src={reactjs} />
            
        </SwiperSlide>
        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700'  src={frontenddec} />
            
        </SwiperSlide>
        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700'  src={Frontend} />
        </SwiperSlide>
        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700'  src={jquery} />
            
        </SwiperSlide>
        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700'  src={Backend} />
        </SwiperSlide>
        <SwiperSlide className='swiper-slide'>
            <img className='shadow-md shadow-violet-700'  src={DSA} />
            
        </SwiperSlide>

        
        </Swiper>

        </div>
    </div>
    <Loader type='ball-scale-multiple'/>
    
</>
  )
}

export default Training